import { render, staticRenderFns } from "./alg.vue?vue&type=template&id=6ec1bcb4&"
import script from "./alg.vue?vue&type=script&lang=js&"
export * from "./alg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports